module.exports = __webpack_public_path__ + "img/60.79245e70.png";